import React, { Component } from "react";
import { HeaderFilter } from "../../../common/header-filter/header-filter.component";
import { connect } from 'react-redux';
const dropdownItem=["Item 1","Item 2", "Item 3"]

const filtersub=[
    {key:31,
    value:"Change Location Address"},
    {key:5,value:"Change Price Plan"},
    {key:4,value:"Change User"},
    {key:14,value:"Change Vendor"},
    {key:29,value:"Change Vendor"},
    {key:27,value:"New Circuit"},
    {key:9,value:"New Mobile Subscription"},
    {key:32,value:"Other"}];

const filterData = [
    {
        id:1,
        filterTitle:"Item 1",
        
    },
    {
        id:2,
        filterTitle:"Item 2",              
    },
    {
        id:3,
        filterTitle:"Item 3",              
    }, {       
        id:4,        
        filterTitle:"Item 4 with Checkbox",              
    }
]

const listItem={
    Tab:[
        {
            "id":"0",
            "label":"Circuit"            
        },
        {
            "id":"1",
            "label":"Equipment"           
        },
        {
            "id":"2",
            "label":"ASPU"           
        },
        {
            "id":"3",
            "label":"ASR"           
        }
    ]
};
class InventoryCircuit extends Component {    
    constructor(props) {
        super(props);
        this.state={
            viewDetailPage:false,
            listSelected:"Circuit",
            tabSelected:0,
            selectedIndex: 0,
        }
    }
    render(){
      
        return(
            <HeaderFilter enableDropdown={true} dropdownItem={dropdownItem} enableFilterBtn={true} filterData={filterData} filtersub={filtersub} enableExportExcel={true} btnAddTitle="Add Plan" 
            enableAddBtn={false} enableUploadBtn={true} listItem={listItem.Tab} haveTab={true}/>          
        )
    }
}

export default connect()(InventoryCircuit);